import {createReducer} from 'redux-act';
import {
  MAKE_REFUND,
  OPEN_CANCELLATION_REFUND_MODAL
} from 'store/global/ordersV2/CancellationRefund/action';

const initialState = () => ({
  isOpenModal: false,
  invoiceId: null,
  showCannotDeliveryText: false,
  loadingRefund: false,
  errorText: null,
  orderId: null
});

const cancellationRefundV2Reducer = createReducer(
  {
    [MAKE_REFUND]: (state) => {
      return {
        ...state,
        loadingRefund: true
      };
    },
    [OPEN_CANCELLATION_REFUND_MODAL]: (state, payload) => {
      return {
        ...state,
        isOpenModal: payload.isOpenModal,
        invoiceId: payload.invoiceId,
        showCannotDeliveryText: payload.showCannotDeliveryText,
        errorText: payload.errorText,
        loadingRefund: payload.loadingRefund || false,
        orderId: payload.orderId || null
      };
    }
  },
  initialState()
);

export default cancellationRefundV2Reducer;
